<button data-cy="button" matButton="text" class="mad-primary" [title]="title()" [type]="type()" [disabled]="disabled()">
  <ng-content></ng-content>
</button>
